import { render, staticRenderFns } from "./AdditionalVisitors.vue?vue&type=template&id=f84d6d3a&scoped=true&"
import script from "./AdditionalVisitors.vue?vue&type=script&lang=js&"
export * from "./AdditionalVisitors.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalVisitors.vue?vue&type=style&index=0&id=f84d6d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84d6d3a",
  null
  
)

export default component.exports